const Ziggy = {"url":"https:\/\/staging.getslurp.com","port":null,"defaults":{},"routes":[]};

if (typeof window !== 'undefined' && typeof window.Ziggy !== 'undefined') {
    Object.assign(Ziggy.routes, window.Ziggy.routes);
}

export { Ziggy };



// WEBPACK FOOTER //
// ./resources/assets/js/ziggy.js